import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { SonicWorkData } from "../../common/classes/SonicWork";
import { getDefaultImage } from "../../utils/GeneralUtils";
import styles from "./WorkModal.module.scss";

type Props = {
  works: SonicWorkData;
  handleClose: () => void;
};
const WorkModal: React.FC<Props> = ({ works, handleClose }) => {
  return (
    <div className={styles["work-modal__wrapper"]}>
      <div className={styles["work-modal"]}>
        <div className={styles["imgBox"]}>
          <img src={works.image ? works.image.large.url : getDefaultImage()} />
        </div>
        {works.link ? (
          <a
            href={works.link}
            target="_blank"
            rel="noreferrer noopener"
            className={styles["work-modal__link"]}
          >
            <FontAwesomeIcon icon={["far", "arrow-up-right-from-square"]} />
            {works.link}
          </a>
        ) : null}
        <div className={styles["work-modal__title"]}>{works.title}</div>
        {works.description ? (
          <div className={styles["work-modal__description"]}>
            {works.description}
          </div>
        ) : null}
        <button
          className={styles["work-modal__close-btn"]}
          type="button"
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={["fas", "times"]} />
        </button>
      </div>
    </div>
  );
};

export default WorkModal;
